import { BookOpenIcon, DumbbellIcon, type LucideIcon } from 'lucide-react';

export interface Pillar {
  icon: LucideIcon;
  tag: string;
  title: string;
  value: string;
  today: string;
  lead: string;
  items: string[];
}

export const pillars: Pillar[] = [
  {
    icon: BookOpenIcon,
    tag: 'Incluido 📚',
    title: 'Los 6 Tomos del Sistema "Sesión en Mano"',
    value: '59,90€',
    today: 'Hoy: Incluido',
    lead: 'Sesiones organizadas y fichas imprimibles para que nunca te falten ejercicios.',
    items: [
      'TOMO 1 — Metodología y Planificación «Cero Estrés»: Organiza la temporada con una ruta de 40 semanas y sesiones completas. Define prioridades, adapta el trabajo al nivel del equipo y utiliza fichas imprimibles para registrar avances y preparar el siguiente entrenamiento.',
      'TOMO 2 — Técnica Individual: 64 fichas de ejercicio de colocación, recepción y defensa, saque y ataque. Cada ficha reúne organización, desarrollo, error frecuente, corrección y opciones para facilitar o progresar. Incluye claves técnicas ilustradas y registros imprimibles.',
      'TOMO 3 — Táctica y Complejos de Juego: 40 tareas colectivas para trabajar recepción y ataque, defensa y contraataque, coberturas, balón fácil y juego fuera de sistema. Con diagramas, organización del grupo y ajustes de dificultad para conectar las tareas con el partido.',
      'TOMO 4 — Preparación Física Integrada: 15 rutinas de 12 minutos para integrar después de la activación: control corporal, fuerza, desplazamientos y preparación del salto. Incluyen dosis, pausas, alternativas y pautas para ajustar la carga al entrenamiento de voleibol.',
      'TOMO 5 — La Pizarra Maestra: Estrategia y Rotaciones: 36 fichas visuales: las seis rotaciones de los sistemas 4-2, 5-1 y 6-2, más situaciones de juego. Referencias para diferenciar posición inicial y función, ensayar con el equipo y corregir desajustes.',
      'TOMO 6 — Gestión del Vestuario y Padres: 20 situaciones prácticas de gestión del equipo, comunicación con familias, participación y competición. Guiones de actuación, seguimiento y ocho fichas imprimibles para acuerdos, conversaciones, revisión de partido y próximos objetivos.'
    ]
  },
  {
    icon: DumbbellIcon,
    tag: 'Incluido 💪',
    title: 'Los 5 Bonos Estratégicos',
    value: '59,50€',
    today: 'Hoy: Incluido',
    lead: 'Los recursos que hacen que el sistema funcione desde el primer día.',
    items: [
      'Bono #1 — Plan de Arranque 7 Días: Una primera semana organizada: observa al equipo, define una prioridad, aplica dos sesiones y decide los siguientes ajustes. Incluye una tercera sesión opcional y las fichas completas para trabajar sin saltar de documento.',
      'Bono #2 — Sesión Express 15 Minutos: 20 sesiones express de 15 minutos de práctica, con activación, tarea técnica, juego y cierre. Para un bloque breve o para integrarlas en un entrenamiento más largo.',
      'Bono #3 — 30 Entrenamientos Listos para Aplicar: 30 sesiones completas de 75 minutos, organizadas en tres niveles. Cada entrenamiento ocupa dos páginas e incluye material, tiempos, tareas, aplicación al juego, errores frecuentes, correcciones y adaptaciones.',
      'Bono #4 — 30 Juegos Técnicos para Base: 30 juegos para trabajar habilidades y decisiones con reglas claras, puntuación, organización del grupo y opciones para facilitar o aumentar el reto. Elige por el nivel real de tus jugadores.',
      'Bono #5 — Mapa de Temporada en una Página: Un mapa imprimible de 40 semanas, con dos propuestas de entrenamiento por semana, objetivos por bloque y criterios de seguimiento. Incluye el mapa cumplimentado, una plantilla en blanco y una guía para adaptarlo a tu calendario.'
    ]
  }
];
